import Header from "./header";
import Content from "./content";

export const ObjectResource = {
	Header: Header,
	Content: Content,
}
